<template>
  <div class="footer reduced-width">
    <div class="footer__copy" v-html="copyright"></div>
    <div class="footer__made-in" v-html="madeIn"></div>
  </div>
</template>

<script>

  export default {
    name: 'footerComponent',
    data() {
      return {
      };
    },
    props: ['copyright', 'madeIn'],
    methods: {
    },
  };
</script>

<style>
  .footer {
    position: relative;
    padding: 40px 25px; 
    font-size: 15px;
    line-height: 150%;

    &__made-in {
      width: 50%;
      position: relative;
      padding-left: 110px;

      span {
        display: block;

        a img {
          position: absolute;
          left: 0;
          top: 4px;
        }
      }
    }

    &__copy {
      float: right;
      width: 50%;
      text-align: right;

      &:after {
        content: '';
        clear: both;
        display: block;
      }

      span {
        margin-right: 15px;

        &:last-child {
          margin-right: 0;
        }
      }
    }
  }

  @media (max-width: 850px) {
    .footer {
      padding: 40px 25px;

      &__made-in,
      &__copy {
        width: 100%;
      }

      &__copy {
        float: none;
        text-align: left;
        margin-bottom: 20px;
      }
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/FooterComponent.vue?b12760f0